var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"img-scroll demo-image__lazy"},_vm._l((_vm.imgs),function(item){return _c('el-image',{key:item,staticStyle:{"width":"120px","height":"80px"},attrs:{"preview-src-list":_vm.imgs,"lazy":"","fit":"cover","src":item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }